/* eslint-disable */
<template>
  <div id="breadcrumb-header">
    <div id="breadcrumbs">
      <v-breadcrumbs large>
        <v-icon slot="divider">chevron_right</v-icon>
        <v-breadcrumbs-item
          :tabindex="item.payload === '' ? -1 : 0"
          v-for="item in breadcrumbs"
          :key="item.text"
          :class="item.payload === '' ? '' : 'active-grey tabable'"
          @click.native="breadcrumbLink(item.payload)"
          @keyup.enter.native="breadcrumbLink(item.payload)"
          :aria-label="createAriaLabel(item.text)"
        >
          <Tooltip v-if="item.text.length > 50" bottom :delay-time="0">
            <div class="bulb-name-truncate" :style="item.text.length > 50 ? 'width: 500px' : ''">
              {{ item.text }}
            </div>
            <template v-slot:text>
              {{ item.text }}
            </template>
          </Tooltip>
          <div v-else class="bulb-name-truncate" :style="item.text.length > 50 ? 'width: 500px' : ''">
            {{ item.text }}
          </div>
        </v-breadcrumbs-item>
      </v-breadcrumbs>
    </div>
  </div>
</template>

<script>

// Plugins / Libraries:
import {
  mapGetters,
  mapActions,
  mapMutations
} from 'vuex';

export default {
  name: 'breadcrumb-header',
  computed: {
    ...mapGetters([
      'breadcrumbs',
      'breadcrumbPayloads',
      'popoverToggles',
    ]),
    ...mapGetters('instructors', [
      'classes',
    ]),
  },
  methods: {
    ...mapActions([
      'setNav',
    ]),
    ...mapMutations('learners', [
      'setAttemptGetPlaylists',
    ]),
    closeFilters: function() {
      this.popoverToggles.filterMenu = false;
      this.popoverToggles.snapshot = false;
      this.popoverToggles.adminFilterMenu = false;
    },
    breadcrumbLink: function(name) {
      if (name) {
        //find payload from link name
        let payload = this.breadcrumbPayloads[name];
        //sets main nav
        this.$store.commit('setNav', [payload.activeView, payload.route]);
        this.closeFilters();
        //if in gradebook, pop off gradebook breadcrumb
        if (name === 'Gradebook' || name === 'Bulbs') {
          payload.breadcrumb.pop();
          this.$store.commit('updateBreadCrumbs', [payload.breadcrumb, {}]);
        } else {
          this.$store.commit('updateBreadCrumbs', [payload.breadcrumb, {}]);
        }

        if (payload.route === 'instructor') {
          //if instructor and not gradebook, reset query params
          if (name != 'Gradebook') this.$store.commit('instructors/resetQueryParams');
          this.$store.commit('instructors/clearAllFiltersNoReload');

          //checks if lms class by class id
          if (payload.queryParams.section_id) {
            this.classes.data.forEach(item => {
              if (item.id === payload.queryParams.section_id) {
                if (item.lmsType != null && item.lmsType != 'Google' && item.lmsType != 'SchoologyFree') {
                  payload.queryParams['lms_class'] = true;
                }
              }
            });
          }

          //set query params, instructor active view, and update url
          this.$store.commit('instructors/setQueryParams', payload.queryParams);
          this.$store.commit('instructors/setActiveView', [payload.activeViewRoute]);
          this.$store.dispatch('instructors/updateUrl');
          if (name === 'My-Bulbs' || name === 'Classes') {
            this.$store.dispatch('instructors/getTableData');
          }
        }

        if (payload.route === 'learner') {
          //if learner, reset query params, set query params, set learner activeview, and update url
          this.$store.commit('learners/resetQueryParams');
          this.$store.commit('learners/setQueryParams', payload.queryParams);
          this.$store.commit('learners/setActiveView', [payload.activeViewRoute]);
          this.setAttemptGetPlaylists(false);
          this.$store.dispatch('learners/updateUrl');
        }

        if (payload.route === 'admin') {
          //if learner, reset query params, set query params, set learner activeview, and update url
          this.$store.commit('admin/resetQueryParams');
          this.$store.commit('admin/setQueryParams', payload.queryParams);
          this.$store.commit('admin/setActiveView', [payload.activeViewRoute]);
          this.$store.dispatch('admin/updateUrl');
        }
      }
    },
    createAriaLabel(text) {
      return `Hot link button back to ${text}. Press enter to go back to ${text}.`;
    },
  },
};
</script>

<style scoped></style>
